import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LookupState {
    itemCustomizations: any[];
    isPointsUpdate: boolean;
}

const initialState: LookupState = {
    itemCustomizations: [],
    isPointsUpdate: false,
};

export const lookupReducer = createSlice({
    name: "lookupReducer",
    initialState,
    reducers: {
        setCustomization: (state, action: PayloadAction<any[]>) => {
            state.itemCustomizations.push(...action.payload);
        },
        clearCustomizations: (state) => {
            state.itemCustomizations = [];
        },
        setIsPointsUpdate: (state, action: PayloadAction<any>) => {
            state.isPointsUpdate = action.payload;
        }
    },
});

export const { setCustomization, clearCustomizations, setIsPointsUpdate } = lookupReducer.actions;
